import script from "./CBA.vue?vue&type=script&setup=true&lang=js"
export * from "./CBA.vue?vue&type=script&setup=true&lang=js"

import "./CBA.vue?vue&type=style&index=0&id=b023a098&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b023a098"]])

export default __exports__